<template lang="pug">
  el-form(label-width="80px" label-suffix=":", :model="form", :rules="rules" ref="form")
    el-form-item(label="账号类型" prop="userType")
      el-select(v-model="form.userType", :disabled="!!user")
        el-option(label="政府账号", :value="1")
        el-option(label="内部账号", :value="2")
    el-form-item(label="角色" prop="role_id")
      el-select(v-model="form.role_id" filterable)
        el-option(
          v-for="city in roleList"
          :label="city.roleDescription"
          :value="city.id"
          :key="city.id"
        )
    el-form-item(label="手机号" prop="userName")
      el-input(v-model="form.userName" style="width: 174px", :disabled="!!user")
    el-form-item(label="密码")
      span 系统自动生成
    el-form-item
      el-button(type="success" @click="submit") {{ `确认${user ? '修改' : '开通'}` }}
</template>

<script>
import { getAllRole, createUser } from '@/api/user';

export default {
  name: 'UserForm',
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        userType: 1,
        userName: '',
        role_id: '',
      },
      rules: {
        role_id: [
          {
            required: true, message: '请选择角色', trigger: 'change'
          }
        ],
        userName: [
          {
            required: true, message: '请输入手机号', trigger: 'change'
          },
          {
            pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号', trigger: 'change'
          }
        ],
      },
      roleList: [],
    };
  },
  computed: {},
  async mounted() {
    const { data } = await getAllRole();
    this.roleList = data;
    if (this.user) {
      this.form = { ...this.user };
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await createUser(this.form);
          this.$message.success(res.info);
          if (res.status === 1) this.$emit('submit');
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/system/userForm.vue?74b68ca4